import orderIndex from './pages/OrderIndex.vue'
import photoReview from './pages/CameraView.vue'
import logoutIndex from './pages/LogoutIndex.vue'




const routers = [
    {
        path: '/orderIndex/:shopId?',
        name: 'orderIndex',
        component: orderIndex
    },
    {
        path: '/photoReview/:orderId',
        name: 'photoReview',
        component: photoReview
    },
    {
        path: '/logoutIndex',
        name: 'logoutIndex',
        component: logoutIndex
    },

    {
        path: '/:shopId?',
        component: orderIndex
    },
]

export default routers
